export class Discipline {

    constructor(public code?: string, public description?: string) {

    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/Discipline.ts